import { ETimelineTimeframe } from 'src/app/project/modules/site/site-timeline/site-timeline-utils/timeframes-enums';
import { DEFAULT_DATE_FORMAT } from '../default-date-format';
import { TPreferences } from '../preferences.model';
import { SET_PREFERENCES } from '../preferences.store';

export const processUserPreferencesResponse = (
  response: TPreferences,
  oldPreferences: TPreferences,
): TPreferences => {
  let preferences = getDefaultPreferences(oldPreferences);

  if (response) {
    preferences = processResponse(response, oldPreferences);
  }

  SET_PREFERENCES(preferences);

  return preferences;
};

function getDefaultPreferences(oldPreferences: TPreferences): TPreferences {
  return {
    commentOnEnter: false,
    dateFormat: DEFAULT_DATE_FORMAT,
    mapZoomFactor: 2.0,
    dashlets: { data: [] },
    overviewExports: {},
    exports: {},
    workspaces: oldPreferences?.workspaces ? oldPreferences?.workspaces : {},
    timeline: {
      timeframe: ETimelineTimeframe.MONTH,
      group: null,
    },
    favouriteWorkspaceIds: [],
    reminderSettings: {
      alerts: true,
      emails: false,
      pushNotifications: false,
    },
  };
}

function processResponse(
  fetchedPreferences: TPreferences,
  oldPreferences: TPreferences,
): TPreferences {
  const timeline = fetchedPreferences.timeline
    ? {
        timeframe: fetchedPreferences.timeline.timeframe
          ? fetchedPreferences.timeline.timeframe
          : ETimelineTimeframe.MONTH,
        group: fetchedPreferences.timeline.group ? fetchedPreferences.timeline.group : null,
      }
    : {
        timeframe: ETimelineTimeframe.MONTH,
        group: null,
      };

  return {
    commentOnEnter: fetchedPreferences.commentOnEnter,
    dateFormat: fetchedPreferences.dateFormat ? fetchedPreferences.dateFormat : DEFAULT_DATE_FORMAT,
    mapZoomFactor: fetchedPreferences.mapZoomFactor ? fetchedPreferences.mapZoomFactor : 2.0,
    dashlets: fetchedPreferences.dashlets ? fetchedPreferences.dashlets : { data: [] },
    workspaces: fetchedPreferences.workspaces
      ? fetchedPreferences.workspaces
      : oldPreferences?.workspaces,
    overviewExports: fetchedPreferences.overviewExports ? fetchedPreferences.overviewExports : {},
    timeline,
    exports: fetchedPreferences.exports ? fetchedPreferences.exports : {},
    favouriteWorkspaceIds: fetchedPreferences.favouriteWorkspaceIds
      ? fetchedPreferences.favouriteWorkspaceIds
      : [],
    reminderSettings: fetchedPreferences.reminderSettings
      ? fetchedPreferences.reminderSettings
      : {
          alerts: true,
          emails: false,
          pushNotifications: false,
        },
  };
}
